import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import eventsApi from '../api/events.api';
import { UpdateDueDatePayload } from '../types/updateDueDate';
import { extractMessageFromError } from '../utils/errorUtils';
import { EventNotUpdated, EventUpdated } from '../displayStrings';

export const useUpdateDueDate = (eventId: number) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  const {
    mutateAsync: updateDueDate,
    isLoading,
    isSuccess,
  } = useMutation(
    (payload: UpdateDueDatePayload): Promise<void> => {
      return eventsApi.updateDueDate(companyId, eventId, payload);
    },
    {
      onSuccess: () => {
        showToast({
          title: EventUpdated,
          description: t('events.modals.dueDateSuccessfullyUpdated'),
          status: 'success',
          'data-cy': 'qe-update-due-date-success-toast',
        });
      },
      onError: (error: AxiosError) => {
        const errorMessage = extractMessageFromError(error);
        showToast({
          title: EventNotUpdated,
          description: errorMessage,
          status: 'error',
        });
      },
    },
  );

  return { updateDueDate, isLoading, isSuccess };
};
